import React, { useEffect, useRef, useState } from "react";
import { Spinner } from "react-bootstrap";
import WidgetSectionTitle from "widgets/WidgetSectionTitle";
import FeedbacksTable from "./FeedbacksTable";

// Hooks
import useFeedbacks from "hooks/feedbacks/useFeedbacks";
import useDebounce from "hooks/route-rules/useDebounce";

export default function Feedbacks() {
  const {
    feedbacks,
    loading,
    totalElements,
    fetchAllFeedbacks,
    fetchFeedbackById,
    deleteFeedbackById,
    searchFeedbacks,
  } = useFeedbacks();

  const [searchTerm, setSearchTerm] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const hasInitializedSearch = useRef(false);

  useEffect(() => {
    if (!hasInitializedSearch.current) {
      hasInitializedSearch.current = true;
      return;
    }

    const trimmedSearch = debouncedSearchTerm.trim();
    if (trimmedSearch.length === 0) {
      fetchAllFeedbacks();
    } else if (trimmedSearch.length >= 3) {
      searchFeedbacks(trimmedSearch);
    }
  }, [debouncedSearchTerm, fetchAllFeedbacks, searchFeedbacks]);

  return (
    <>
      <WidgetSectionTitle
        icon="comment"
        title="Feedbacks"
        subtitle="View, track, and manage all user feedback efficiently in one place."
        transform="shrink-2"
        className="mb-3 mt-3"
      />

      {/* Notice: We removed the search Row from here. 
          We pass searchTerm props to FeedbacksTable so it looks exactly like 
          your App Versions and Affiliations tables.
      */}
      <FeedbacksTable
        feedbacks={feedbacks}
        loading={loading}
        totalElements={totalElements}
        getFeedback={fetchFeedbackById}
        deleteFeedback={deleteFeedbackById}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
    </>
  );
}